import { brandfolderColorPalette } from '@brandfolder/react';
import React, { FunctionComponent, useState } from 'react';

import styled from 'styled-components';

import { I18nProviderWrapper } from '@components/common/I18nProviderWrapper';
import { DialogProvider } from '@components/common/providers/DialogContextProvider';

import { AddCustomRoleCard } from './AddCustomRoleCard';
import { CreateCustomRolePage } from './CreateCustomRolePage';

type View = 'card' | 'create';

interface CustomRoleManagerProps {
}

export const CustomRoleManagerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${brandfolderColorPalette.neutrals[0]};
  z-index: 100;
  overflow-y: auto;
}
  `;

export const CustomRoleManager: FunctionComponent<CustomRoleManagerProps> = ({
}) => {
  const [currentView, setCurrentView] = useState<View>('card');

  const handleShowCreatePage = (): void => {
    setCurrentView('create');
  };

  const handleBackToCard = (): void => {
    setCurrentView('card');
  };

  const handleSave = (): void => {
    setTimeout(() => {
      document.getElementById('custom-role-usage-card')?.classList.add('has-custom-role');
    }, 100);
  };

  if (currentView === 'create') {
    // When showing create page, render it at a higher level to take full width
    return (
      <I18nProviderWrapper>
        <DialogProvider>
          <CustomRoleManagerWrapper>
            <CreateCustomRolePage
              onBack={handleBackToCard}
              onSave={handleSave}
              organizationKey={BFG.organization_key}
              userCount={0}
            />
          </CustomRoleManagerWrapper>
        </DialogProvider>
      </I18nProviderWrapper>
    );
  }

  return (
    <I18nProviderWrapper>
      <AddCustomRoleCard onNavigateToCreate={handleShowCreatePage} />
    </I18nProviderWrapper>
  );
};
